/**
 * Created by nijin on 4/7/17.
 */
import {Component, OnInit, ViewChild, Input, OnChanges} from '@angular/core';
import {EventFormService} from '../event-simulation/event-form.service';
import {FormGroup} from '@angular/forms';
import {ThingsService} from '../../things.service';
import {NotificationBarService} from '../../../core/notify/notification.service';
import {NotificationType} from '../../../core/notify/index';

@Component({
    selector: 'nuc-location-popup',
    templateUrl: './location-popup.component.html',
    styles: [
    `
    `
    ]
})
export class LocationPopup implements OnInit, OnChanges {

  public locationForm: FormGroup = new  FormGroup({});
  public isLoading = false;
  @Input() schema: any;
  @Input() thing;
  @Input() eventData;
  @ViewChild('location') location ;
  constructor(private locForm: EventFormService,
                private thingService: ThingsService,
                private notifier: NotificationBarService) { }

    ngOnInit() {

    }

    ngOnChanges() {
      this.buildForm();
    }



    buildForm() {
      if (this.schema.location) {
        const location = this.eventData ? this.eventData.location : null;
        this.locationForm = this.locForm.locationToForm(this.schema.location, location);
      }
    }

    open() {
      this.buildForm();
       this.location.open();
    }

    saveLocation() {
        if (this.locationForm.valid) {
          this.isLoading = true;
          this.thing.location = this.locationForm.value;
          this.thingService.updateThing(this.thing)
            .subscribe((response) => {this.isLoading = false;
                this.close();
                this.thingService.updateThingSubject(response.data, true);
            this.notifier.create({type: NotificationType.Success, message: response.status.message}); },
              err => {this.isLoading = false; }

          );
        }
    }

    close() {
     // this.locationForm.reset();
      this.location.hide();
    }


}



// WEBPACK FOOTER //
// ./src/app/things/things-details/location-details/location.popup.ts